import { render, staticRenderFns } from "./_EmailForm.vue?vue&type=template&id=55ac2ca1"
import script from "./_EmailForm.vue?vue&type=script&lang=js"
export * from "./_EmailForm.vue?vue&type=script&lang=js"
import style0 from "./_EmailForm.vue?vue&type=style&index=0&id=55ac2ca1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports